import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import { HumanizePipe } from '@shared/pipes/humanize.pipe';

export function enumToSource(enumName: object) {
  return Object.entries(enumName)
    .filter(e => !isNaN(+e[1]))
    .map(e => ({ label: HumanizePipe.transform(e[0]), value: e[1] } as IRadioButtonOption<number>));
}
